module.exports = __webpack_public_path__ + "static/media/popcorn.3293262b.svg";